import { Select } from "antd";
import React, { useEffect, useState } from "react";
import { FaMinus, FaPlus } from "react-icons/fa6";
import { TiDelete } from "react-icons/ti";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";

const tempData = [
  {
    label: "IOR",
    items: [
      "IOR",
      "Export documentation",
      "Customs clearance",
      "Handling",
      "Collection",
      "Airfreight",
      "Administration",
      "Duties and taxes",
      "Compliance",
      "VAT",
      "Final delivery",
      "Destination charges",
      "Leiability coverage",
      "Approvals",
      "Import permit",
      "Bank fees",
      "Validation",
      "THC",
    ],
  },
  {
    label: "EOR",
    items: [
      "EOR",
      "Export clearance",
      "Export documentation",
      "Collection",
      "Airfreight",
      "Handling",
      "Administration",
      "Bank fees",
      "Export compliance",
    ],
  },
  {
    label: "EOR & IOR",
    items: [
      "EOR",
      "Export documentation",
      "IOR",
      "Customs clearance",
      "Handling",
      "Collection",
      "Airfreight",
      "Administration",
      "Duties and taxes",
      "Compliance",
      "VAT",
      "Final delivery",
      "Destination charges",
      "Leiability coverage",
      "Approvals",
      "Import permit",
      "Bank fees",
      "Validation",
      "THC",
    ],
  },
];

for (let i = 0; i < tempData.length; i++) {
  for (let j = 0; j < tempData[i].items.length; j++) {
    tempData[i].items[j] = tempData[i].items[j].toUpperCase();
  }
}

const ServiceTemp = ({
  formData,
  setFormData,
  validationErrors,
  setValidationErrors,
  templateSelected,
  attemptedSubmit,
  setTemplateSelected,
}) => {
  useEffect(() => {
    if (!formData.selectedTemplate) {
      setTemplateSelected(false);
    } else {
      setTemplateSelected(true);
    }
  }, [formData.selectedTemplate, setTemplateSelected]);

  const getValidationErrorClass = (index, field) => {
    return validationErrors[`service_${index}_${field}`]
      ? "border-red-500"
      : "active:border-cus-blue focus:border-cus-blue";
  };

  const validateField = (value, field) => {
    if (field === 'numberOfItem') {
      return value.trim() !== '' && !isNaN(value) && parseFloat(value) > 0;
    }
    if (field === 'description') {
      return value.trim() !== '';
    }
    // if (field === 'exclVAT') {
    //   return value.trim() !== '' && !isNaN(value) && parseFloat(value) >= 0;
    // }
    return true;
  };

  const handleServiceInputChange = (index, field, e) => {
    const { value } = e.target;
    let sanitizedValue = value;

    if (field === "numberOfItem") {
      // Only sanitize numberOfItem
      sanitizedValue = value.replace(/[^0-9.]/g, "");
      const parts = sanitizedValue.split(".");
      if (parts.length > 2) {
        parts.pop();
      }
      sanitizedValue = parts.join(".");
      if (parseFloat(sanitizedValue) <= 0 || isNaN(parseFloat(sanitizedValue))) {
        sanitizedValue = "";
      }
    } else if (field === "exclVAT") {
      // For exclVAT, just allow any numeric value including 0
      sanitizedValue = value.replace(/[^0-9.]/g, "");
      const parts = sanitizedValue.split(".");
      if (parts.length > 2) {
        parts.pop();
      }
      sanitizedValue = parts.join(".");
    }
  
    const isValid = validateField(sanitizedValue, field);
  
    const updatedServices = [...formData.services];
    updatedServices[index][field] = sanitizedValue;
    
    const updatedFormData = {
      ...formData,
      services: updatedServices,
    };
    // Use the setFormData prop which contains the updateHasChanges logic
    setFormData(updatedFormData);
  
    // Only set validation errors for non-exclVAT fields
    if (field !== "exclVAT") {
      setValidationErrors((prev) => ({
        ...prev,
        [`service_${index}_${field}`]: !isValid,
      }));
    }
  };

  const sanitizeNumericInput = (value) => {
    // Remove any non-numeric characters except decimal point
    let sanitized = value.replace(/[^0-9.]/g, "");

    // Ensure only one decimal point
    const parts = sanitized.split(".");
    if (parts.length > 2) {
      parts.pop();
    }
    sanitized = parts.join(".");

    // Convert to number and check if it's positive and not zero
    const numValue = parseFloat(sanitized);
    if (numValue <= 0 || isNaN(numValue)) {
      return "";
    }
    return sanitized;
  };

  const sanitizeNumericInputForVAT = (value) => {
    // Remove any non-numeric characters except decimal point
    let sanitized = value.replace(/[^0-9.]/g, "");

    // Ensure only one decimal point
    const parts = sanitized.split(".");
    if (parts.length > 2) {
      parts.pop();
    }
    return parts.join(".");
  };

  const handleTemplateChange = (e) => {
    const templateLabel = e;
    setTemplateSelected(true);
    const selectedTemplateData = tempData.find(
      (template) => template.label === templateLabel
    );
    if (selectedTemplateData) {
      const itemsDescription = selectedTemplateData.items;
      const generatedServices = itemsDescription.map((description) => ({
        numberOfItem: 1 || "",
        description: description,
        exclVAT: "",
      }));
      const updatedFormData = {
        ...formData,
        selectedTemplate: templateLabel,
        services: generatedServices,
      };
      setFormData(updatedFormData);
    } else {
      const updatedFormData = {
        ...formData,
        selectedTemplate: templateLabel,
      };
      setFormData(updatedFormData);
    }
  };

  const handleRemoveService = () => {
    const updatedFormData = {
      ...formData,
      services: formData.services.slice(0, -1), 
    };
    setFormData(updatedFormData);
  };
  
  const handleAddMore = () => {
    const updatedFormData = {
      ...formData,
      services: [...formData.services, {}],
    };
    setFormData(updatedFormData);
  };

  // const handleServiceInputChange = (index, field, e) => {
  //   const { value } = e.target;

  //   setFormData((prevData) => {
  //     const updatedServices = [...prevData.services];
  //     updatedServices[index][field] = value;

  //     return {
  //       ...prevData,
  //       services: updatedServices,
  //     };
  //   });
  // };

  const handleRemove = (index) => {
    setFormData((prevData) => ({
      ...prevData,
      services: prevData.services.filter((_, i) => i !== index), // Remove the service at the specified index
    }));
  };

  const onDragEnd = (result) => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    const items = reorder(
      formData.services,
      result.source.index,
      result.destination.index
    );

    setFormData({
      ...formData,
      services: items,
    });
  };

  const getItemStyle = (isDragging, draggableStyle) => ({
    userSelect: "none",
    padding: "",
    margin: "0 0 0 0",
    background: isDragging ? "gray" : "white",
    ...draggableStyle,
  });

  const getListStyle = (isDraggingOver) => ({
    background: isDraggingOver ? "lightblue" : "white",
    padding: "4px",
    width: "100%",
  });

  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };

  return (
    <div className="pb-5 ">
      <div className="w-full flex flex-col gap-5 py-3">
        <h2 className="mx-[30px] font-bold text-xl mt-4">
          Select Template
        </h2>
        <div className="lg:w-1/2 flex gap-2 items-start md:px-5 ">
          <h2 className="mt-1 px-3 ">Select Template</h2>

          <Select
            name="selectedTemplate"
            id="selectedTemplate"
            placeholder="Select Template"
            style={{
              width: "50%",
              /*
                border:
                attemptedSubmit && !formData.selectedTemplate
                  ? "1px solid red"
                  : undefined,
              */
            }}
            onChange={handleTemplateChange}
            value={formData.selectedTemplate}
            options={tempData.map((temp, i) => ({
              label: temp.label,
              value: temp.label,
            }))}
            showSearch
          />
          <div className="lg:w-1/2 flex gap-2 items-start md:px-5 ">
            <h1 className="mt-1 px-3">Currency</h1>
            <Select
              name="currency"
              id="currency"
              onChange={(e) =>
                setFormData((prevFormData) => ({
                  ...prevFormData,
                  currency: e,
                }))
              }
              value={formData.currency}
              options={[
                { value: "USD", label: "USD" },
                { value: "EUR", label: "EUR" },
                { value: "GBP", label: "GBP" },
              ]}
              showSearch
            ></Select>
          </div>
        </div>

      </div>
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="droppable">
          {(provided, snapshot) => (
            <div
              {...provided.droppableProps}
              ref={provided.innerRef}
              style={getListStyle(snapshot.isDraggingOver)}
            >
              {formData.services.map((formItem, index) => (
                <Draggable
                  key={index.toString()}
                  draggableId={index.toString()}
                  index={index}
                >
                  {(provided, snapshot) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      style={getItemStyle(
                        snapshot.isDragging,
                        provided.draggableProps.style
                      )}
                    >
                      <div className="flex flex-col items-center gap-3 w-full md:px-7">
                        <div className="flex flex-col lg:flex-row gap-3 mx-[30px] w-full" key={index}>
                          {/* Number of Items Input */}
                          <div className="w-full lg:w-[20%] flex flex-col gap-1 py-2 relative">
                            <label className="w-full text-sm font-normal" htmlFor={`numberOfItem-${index}`}>
                              Number
                            </label>
                            <input
                              type="text"
                              className={`w-full h-8 p-2 text-sm border rounded-md outline-none`}
                              id={`numberOfItem-${index}`}
                              onChange={(e) => handleServiceInputChange(index, "numberOfItem", e)}
                              value={formItem.numberOfItem}
                            />
                            {/* {validationErrors[`service_${index}_numberOfItem`] && (
                              <p className="text-red-500 text-xs mt-1">Please enter a valid positive number.</p>
                            )} */}
                          </div>

                          {/* Description Input */}
                          <div className="w-full lg:w-[50%] flex flex-col gap-1 py-2">
                            <label className="w-full text-sm font-normal" htmlFor={`description-${index}`}>
                              Description
                            </label>
                            <input
                              type="text"
                              className={`w-full h-8 p-2 text-sm border rounded-md outline-none`}
                              id={`description-${index}`}
                              onChange={(e) => handleServiceInputChange(index, "description", e)}
                              value={formItem.description}
                              maxLength={1000}
                            />
                            {/* {validationErrors[`service_${index}_description`] && (
                              <p className="text-red-500 text-xs mt-1">Description is required.</p>
                            )} */}
                          </div>

                          {/* Excl. VAT Input - Modified to remove validation messages */}
                          <div className="w-full lg:w-[10%] flex flex-col gap-1 py-2">
                            <label className="w-full text-[gray] text-sm font-normal" htmlFor={`exclVAT-${index}`}>
                              excl.VAT
                            </label>
                            <input
                              type="text"
                              className="w-full h-8 p-2 text-sm border rounded-md outline-none"
                              id={`exclVAT-${index}`}
                              onChange={(e) => handleServiceInputChange(index, "exclVAT", e)}
                              value={formItem.exclVAT}
                            />
                          </div>

                          {/* Total calculation */}
                          <div className="lg:w-[20%] flex gap-2">
                            <div className="w-32">
                              <h1 className="mt-2">Total</h1>
                              <p className="text-[gray] w-full p-1 text-sm border rounded-md">
                                {(
                                  parseFloat(formItem.exclVAT || 0) *
                                  parseFloat(formItem.numberOfItem || 1)
                                ).toFixed(2)}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
        <div className="flex gap-2 items-center">
          <div className="mx-[30px] mt-3 " onClick={handleAddMore}>
            <FaPlus className="text-[20px] text-[#03336E] " />
          </div>

          <div className="mx-[10px] mt-3 " onClick={handleRemoveService}>
            <FaMinus className="text-[20px] text-[#03336E] " />
          </div>
        </div>
      </DragDropContext>
    </div>
  );
};

export default ServiceTemp;